<template>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="$emit('closeModal')">
          <div class="row">
            <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
              <div class="modal-container" @click.stop>
  
                <div class="modal-header row" style="justify-content: flex-end;">
                  <!-- <div class="col-6">
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                  </div> -->
                  <div class="col">
                    <button type="button" class="close" @click="$emit('closeModal')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
  
                <div class="modal-body">
                  <h2 class="title">Tambah Salvage Part</h2>
                  <form>
                    <div class="row row-space">
                      <div class="col-md-6">
                        <div class="input-group">
                          <label class="label">Work Order<span style="color: red;">*</span></label>
                          <MultiSelect
                            v-model="form.work_order_code"
                            :options="prop_options.workorder"
                            :allow-empty="false"
                            placeholder="Pilih Work Order"
                            disabled
                          ></MultiSelect>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="input-group">
                          <label class="label">Sparepart<span style="color: red;">*</span></label>
                          <MultiSelect
                            v-model="selected.sparepart"
                            :disabled="!form.work_order_code"
                            :options="options.sparepart"
                            track-by="id"
                            label="name"
                            :allow-empty="false"
                            placeholder="Pilih Sparepart"
                          ></MultiSelect>
                        </div>
                      </div>
                    </div>
                    <div class="row row-space">
                      <div class="col-sm-6">
                        <div class="input-group">
                          <label class="label">Jumlah<span style="color: red;">*</span></label>
                          <input class="input--style-4" type="text" name="name" v-model="form.amount" disabled placeholder="Ketik Jumlah">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="input-group">
                          <label class="label">Tanggal Salvage<span style="color: red;">*</span></label>
                          <flat-pickr
                            v-model="form.salvage_date"
                            :config="rangeConfig"
                            placeholder="Pilih Tanggal Salvage"
                          ></flat-pickr>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col mt-5" style="text-align: center">
                        <button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
                        <button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm()">Tambah</button>
                      </div>
                    </div>
                  </form>
                </div>
            </div>
          </div>
        </div>
        <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
      </div>
    </div>
  </transition>
  </template>
  
  <script>
    import MultiSelect from 'vue-multiselect';
  
    export default {
      data () {
        return {
          options : {
            sparepart : [],
            laborerType : this.$store.getters.getLaborerType
          },
          rangeConfig: {
            altInput: true,
            altInputClass: 'form-control input flatpickr-input w-100',
            animate: !this.isRTL()
          },
          selected : {
            sparepart : null,
          },
          form : {
            work_order_code : this.workOrderCode,
            sparepart_id : null,
            insurance_id : null,
            amount : null,
            salvage_date : ''
          }
        }
      },
      props : ['prop_options', 'workOrderCode'],
      components:{
        MultiSelect,
      },
      mounted () {
        this.getListOfSpareparts(this.form.work_order_code)
      },
      watch : {
        'form.work_order_code' () {
            this.form.sparepart_id = null;
            this.selected.sparepart = null;
            this.getListOfSpareparts(this.form.work_order_code)
        },
        'selected.sparepart' () {
            if(this.selected.sparepart){
                this.form.sparepart_id = this.selected.sparepart.id
                this.form.amount = parseFloat(this.selected.sparepart.amount)
            }
        },
      },
      methods : {
        getListOfSpareparts(workorder){
            this.$http.get(`/api/v1/workorder-estimation/${workorder}`)
            .then((resp)=>{
                this.options.sparepart = resp.data.data.estimations.filter(x=>x.sparepart_type=='P').map((x)=>{return{id:x.sparepart_id, name:x.sparepart_name, amount:x.amount}})
                this.form.insurance_id = resp.data.data.details.insurance_id
            })
            .catch((err)=>{console.log(err)})
        },
        validateForm(){
          var valid = true;
          var error = [];
  
          if(this.form.work_order_code == '' || this.form.work_order_code == null){//Work order [Required]
            valid = false;
            error.push('Work order wajib diisi');
          }
  
          if(this.form.sparepart_id == '' || this.form.sparepart_id == null){//Sparepart [Required]
            valid = false;
            error.push('Sparepart wajib diisi');
          }
  
          if(this.form.salvage_date == '' || this.form.salvage_date == null){//Tanggal Salvage [Required]
            valid = false;
            error.push('Tanggal salvage wajib diisi!');
          }
  
          if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
          else return valid;
        },
        async submitForm(){
          let vm = this;
          if(vm.validateForm()){

            // if(!this.form.insurance_id) delete this.form.insurance_id

            this.$http.post('/api/v1/salvage-part/', this.form)
            .then((resp)=>{
              // alert(`Partshop ${vm.form.name} has been created`);
              this.$store.dispatch('triggerAlert', [true, [`Salvage part telah berhasil ditambahkan`]]);
              this.$emit('updateTable');
              this.$emit('closeModal');
            })
            .catch((err)=>{
              console.log(err);
              this.$store.dispatch('triggerAlert', [false, ['An Error has occured']]);
            })
          }
        },
      }
    }
  </script>
  
  <style scoped>
  
  /* ==========================================================================
  #FORM made by Colorlib (https://colorlib.com)
  ========================================================================== */
  input {
    outline: none;
    margin: 0;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
  }
  
  .input--style-4 {
    line-height: 50px;
    background: #fafafa;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 16px;
    color: #666;
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    transition: all 0.4s ease;
  }
  
  .input--style-4::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #666;
  }
  
  .input--style-4:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #666;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Microsoft Edge */
    color: #666;
  }
  
  .input--style-4:disabled {
    background-color: #d6d6d6;
  }
  
  .label {
    font-size: 16px;
    color: #555;
    text-transform: capitalize;
    display: block;
    margin-bottom: 5px;
  }
  
  .radio-container {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  .radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  
  .radio-container input:checked ~ .checkmark {
    background-color: #e5e5e5;
  }
  
  .radio-container input:checked ~ .checkmark:after {
    display: block;
  }
  
  .radio-container .checkmark:after {
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #57b846;
  }
  
  .checkmark {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #e5e5e5;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  }
  
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  .input-group {
    position: relative;
    /* margin-bottom: 22px; */
    padding:20px;
  }
  
  .input-group-icon {
    position: relative;
  }
  
  .input-icon {
    position: absolute;
    font-size: 18px;
    color: #999;
    right: 18px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
  }
  
  /* ==========================================================================
      #TITLE made by Colorlib (https://colorlib.com)
      ========================================================================== */
  .title {
    font-size: 40px;
    color: #525252;
    margin-bottom: 40px;
    text-align: center;
  }
  </style>
  